var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 61,
    viewBox: "0 0 62 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_399_7281)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.0831 20.8606L28.3193 20.8596C27.4024 20.8596 26.6592 21.5957 26.6592 22.504V29.0747C26.6592 29.9828 27.4024 30.7191 28.3192 30.7191H40.0121C38.7317 34.0107 36.3419 36.7673 33.293 38.5188L38.2788 47.0685C46.2767 42.4865 51.0051 34.447 51.0051 25.4472C51.0051 24.1658 50.9098 23.2497 50.7191 22.2183C50.5741 21.4346 49.8873 20.8606 49.0831 20.8606Z",
    fill: "#167EE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5519 40.591C19.8296 40.591 14.8341 37.4939 12.1511 32.9109L3.52051 37.8387C7.91258 45.3792 16.1403 50.457 25.5519 50.457C30.1688 50.457 34.5253 49.2256 38.2782 47.0796V47.0679L33.2923 38.5181C31.0117 39.8284 28.3726 40.591 25.5519 40.591Z",
    fill: "#12B347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.28 47.0845V47.0728L33.2942 38.5229C31.0136 39.8331 28.3747 40.5958 25.5537 40.5958V50.4619C30.1707 50.4619 34.5274 49.2305 38.28 47.0845Z",
    fill: "#0F993E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0613 25.244C10.0613 22.45 10.831 19.836 12.1535 17.577L3.52285 12.6492C1.34457 16.355 0.101562 20.6588 0.101562 25.244C0.101562 29.8293 1.34457 34.1331 3.52285 37.8389L12.1535 32.9111C10.831 30.6521 10.0613 28.0381 10.0613 25.244Z",
    fill: "#FFD500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5519 9.89728C29.2834 9.89728 32.7109 11.2107 35.3881 13.3955C36.0486 13.9344 37.0085 13.8955 37.6135 13.2962L42.3133 8.64066C42.9997 7.9607 42.9508 6.84767 42.2176 6.21754C37.732 2.36278 31.8958 0.03125 25.5519 0.03125C16.1403 0.03125 7.91258 5.10905 3.52051 12.6496L12.1511 17.5774C14.8341 12.9944 19.8296 9.89728 25.5519 9.89728Z",
    fill: "#FF4B26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.39 13.3955C36.0504 13.9344 37.0105 13.8955 37.6154 13.2962L42.3152 8.64067C43.0015 7.9607 42.9526 6.84767 42.2194 6.21754C37.7339 2.36268 31.8977 0.03125 25.5537 0.03125V9.89729C29.2851 9.89729 32.7128 11.2107 35.39 13.3955Z",
    fill: "#D93F21"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_399_7281"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 61.2733,
    height: 60.6969,
    fill: "white",
    transform: "translate(0.101562 0.03125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/Google.a957bbd0ef996878efd8045b705b700b.svg";
export { ForwardRef as ReactComponent };